<template>
  <section>
    <div class="view-desktop">
      <div v-if="agendamentos" class="fast">
        <h6>{{ this.$t('cards.compromissos') }}</h6>
        <div class="card">
          <div class="card-content">
            <ul class="list">
              <li
                class="item"
                v-for="(i, index) in agendamentos"
                :key="i.CodigoAtendimento"
                @click="modalPreparo(i.CodigoAtendimento, i.TemPreparo)"
              >
                <div class="info columns is-vcentered">
                  <div
                    class="date is-one-fifth has-text-centered"
                    v-if="
                      index === 0 ||
                        i.DataVaga !== agendamentos[index - 1].DataVaga
                    "
                  >
                    <span class="day">{{ dayFormat(i.DataVaga) }}</span>
                    <span class="mounth">{{ monthFormat(i.DataVaga) }}</span>
                  </div>
                  <div class="date is-one-fifth has-text-centered" v-else>
                    <span class="day">&nbsp;</span>
                    <span class="mounth">&nbsp;</span>
                  </div>
                  <div class="line" />
                  <div class="text column">
                    <div class="examTitle">
                      <span>
                        {{ i.Descricao }}
                        <i
                          class="icon-ic_alert-blue is-pulled-right"
                          v-if="i.TemPreparo"
                        />
                      </span>
                    </div>
                    <span>
                      {{ $t('labels.horario') }}: {{ i.Hora }} -
                      {{ textoObservacao(i.FormaAtendimento) }}
                    </span>
                  </div>
                </div>
                <hr
                  v-if="
                    index < agendamentos.length - 1 &&
                      i.DataVaga !== agendamentos[index + 1].DataVaga
                  "
                />
              </li>
            </ul>
          </div>
        </div>
        <router-link to="/agenda" class="all is-pulled-right is-vcentered">
          {{ this.$t('botoes.ver-todos') }}
        </router-link>
      </div>
    </div>

    <div class="view-mobile">
      <div v-if="agendamentos" class="fast">
        <h6>{{ this.$t('cards.compromissos') }}</h6>
        <div class="card">
          <div class="card-content">
            <ul class="list">
              <li
                v-for="(exam, index) in agendamentos"
                :key="exam.CodigoAtendimento"
                class="item"
              >
                <div class="date">
                  <div class="day" v-if="dayFormat">
                    <p>{{ dayFormat(exam.DataVaga) }}</p>
                    <p class="mounth">
                      {{ monthFormat(exam.DataVaga) }}
                    </p>
                  </div>
                </div>
                <div class="exam_description">
                  <p class="descricao">
                    {{ exam.Descricao }}
                  </p>
                  <p class="time">
                    {{ $t('labels.horario') }}: {{ exam.Hora }} -
                    {{ textoObservacao(exam.FormaAtendimento) }}
                  </p>
                </div>
                <hr v-if="index == agendamentos.length - 1 ? false : true" />
              </li>
            </ul>
          </div>
        </div>
        <router-link to="/agenda" class="all is-pulled-right is-vcentered">
          {{ this.$t('botoes.ver-todos') }}
        </router-link>
      </div>
    </div>

    <preparation-modal
      v-if="mostrarModal"
      :toggle="mostrarModal"
      :dados-exames="this.getExameSelecionado"
      @closeModal="modalPreparo()"
    />
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PreparationModal from '@/components/shared/modal/PreparationModal'
import router from '@/router'
import { NotAuthenticatedError } from '../../../models/not-authenticated-error'
import { FormaAtendimento } from '../../../mixins/forma-atendimento'
import { format, parse } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export default {
  name: 'ExamCard',
  components: {
    PreparationModal
  },
  computed: {
    ...mapGetters({
      agendamentos: 'proximosAgendamentos',
      getExameSelecionado: 'ExameSelecionado'
    })
  },
  data() {
    return {
      mostrarModal: false
    }
  },
  beforeMount() {
    this.getProximosAgendamentos(process.env.VUE_APP_QUANTIDADE_ITENS).catch(
      (err) => {
        if (err instanceof NotAuthenticatedError) router.push('/')
      }
    )
  },
  methods: {
    ...mapActions(['getProximosAgendamentos', 'getDadosExame']),
    modalPreparo(codigoAtendimento, temPreparo) {
      if (temPreparo) {
        this.getDadosExame(codigoAtendimento).then(() => {
          this.mostrarModal = !this.mostrarModal
        })
      } else {
        this.mostrarModal = false
      }
    },
    dayFormat(value) {
      return format(parse(value, 'dd/MM/yyyy', new Date()), 'dd')
    },
    monthFormat(value) {
      return format(parse(value, 'dd/MM/yyyy', new Date()), 'MMM', {
        locale: ptBR
      })
    },
    textoObservacao(formaAtendimento) {
      switch (formaAtendimento) {
        case FormaAtendimento.Videoconferencia:
          return this.$t('agenda.video')
        case FormaAtendimento.Telefone:
          return this.$t('agenda.telefone')
        default:
          return this.$t('agenda.presencial')
      }
    }
  }
}
</script>

<style lang="scss" scoped src="@/assets/stylesheets/components/home/fastcards/ExamCard.scss"></style>
